module.exports = __webpack_public_path__ + "static/img/wlp1060.3aedcc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wlp1060.jpg
// module id = ntwg
// module chunks = 0